<template>
    <modal-box v-model="isModalActive" :title="__('Please confirm action')" has-cancel @confirm="confirmDeletion">
        <p>{{ __('Are you sure you want to delete this resource?') }}</p>
    </modal-box>

    <div v-if="checkedRows.length" class="bg-gray-50 p-3">
        <span v-for="checkedRow in checkedRows" :key="checkedRow.id"
              class="inline-block bg-gray-100 px-2 py-1 rounded-sm mr-2 text-sm">{{ checkedRow.name }}</span>
    </div>

    <table>
        <thead>
        <tr>
            <th v-if="checkable"></th>
            <th>{{ __('ID') }}</th>
            <th>{{ __('Name') }}</th>
            <th>{{ __('Email') }}</th>
            <th>{{ __('Roles') }}</th>
            <th>{{ __('Created') }}</th>
            <th></th>
        </tr>
        </thead>
        <tbody>
        <tr v-for="user in itemsPaginated" :key="user.id">
            <checkbox-cell v-if="checkable" @checked="checked($event, user)"/>
            <td :data-label="__('ID')">{{ user.id }}</td>
            <td :data-label="__('Name')">{{ user.name }}</td>
            <td :data-label="__('Email')">{{ user.email }}</td>
            <td :data-label="__('Roles')">
                <div v-for="role in user.roles" :key="role.id">
                    <span class="bg-blue-600 px-1 py-0.5 rounded text-white">{{ role.name }}</span>
                </div>
            </td>
            <td :data-label="__('Created')">
                <small class="text-gray-500" :title="user.created_at">
                    {{ moment(user.created_at).locale('uk').calendar() }}
                </small>
            </td>
            <td class="actions-cell">
                <jb-buttons type="justify-start lg:justify-end" no-wrap>
                    <jb-button class="mr-3" color="success" :icon="mdiPencil" small
                               @click.prevent="$inertia.visit(route('users.edit', user.id))"/>
                    <jb-button color="danger" :icon="mdiTrashCan" small @click="deleteItemConfirmation(user.id)"/>
                </jb-buttons>
            </td>
        </tr>
        </tbody>
    </table>
    <pagination
        :current-page="currentPage"
        :total-pages="numPages"
        @page-changed="currentPage = $event"
    />
</template>

<script>
import {computed, ref} from 'vue'
import {mdiEye, mdiPencil, mdiTrashCan} from '@mdi/js'
import ModalBox from "@/Components/Dashboard/ModalBox";
import CheckboxCell from '@/Components/Dashboard/CheckboxCell'
import Level from '@/Components/Dashboard/Level'
import JbButtons from '@/Components/Dashboard/JbButtons'
import JbButton from '@/Components/Dashboard/JbButton'
import moment from 'moment'
import Pagination from "@/Components/Dashboard/Pagination.vue";

export default {
    name: 'UsersTable',
    components: {
        Pagination,
        ModalBox,
        CheckboxCell,
        Level,
        JbButtons,
        JbButton
    },
    props: {
        checkable: Boolean,
        items: Object
    },
    methods: {
        deleteItemConfirmation(itemId) {
            this.isModalActive = true
            this.itemForDeleteId = itemId
        },
        confirmDeletion() {
            this.$inertia.form().delete(this.route('users.destroy', this.itemForDeleteId), {
                onFinish: () => this.itemForDeleteId = false
            })
        }
    },
    setup(props) {

        const items = computed(() => props.items)

        const isModalActive = ref(false)

        const perPage = ref(10)

        const currentPage = ref(0)

        const checkedRows = ref([])

        const itemsPaginated = computed(
            () => items.value.slice(perPage.value * currentPage.value, perPage.value * (currentPage.value + 1))
        )

        const numPages = computed(() => Math.ceil(items.value.length / perPage.value))

        const remove = (arr, cb) => {
            const newArr = []

            arr.forEach(item => {
                if (!cb(item)) {
                    newArr.push(item)
                }
            })

            return newArr
        }

        const checked = (isChecked, client) => {
            if (isChecked) {
                checkedRows.value.push(client)
            } else {
                checkedRows.value = remove(checkedRows.value, row => row.id === client.id)
            }
        }

        return {
            isModalActive,
            currentPage,
            numPages,
            checkedRows,
            itemsPaginated,
            checked,
            mdiEye,
            mdiTrashCan,
            mdiPencil,
            moment
        }
    }
}
</script>
